import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import { Link } from '@kurtosys/ksys-app-components/dist/components/base/Link/Link';

export default InjectedStyledComponent(Link, 'links', ['link']);